import React from "react";
import Image from "next/image";
import type { PartnershipCard } from "./data";

export default function PressList({ items }: { items: PartnershipCard[] }) {
  return (
    <div className="w-full">
      <div className="grid grid-cols-1 2xl:grid-cols-3 gap-0">
        {items?.map((card, idx) => (
          <div
            key={idx}
            className={`flex flex-col gap-16 p-[42px] border border-[#ecf0f6] ${
              idx === 0 ? "" : "lg:border-l-0"
            } ${idx === 1 ? "bg-[#ECF0F6]" : "bg-transparent"}`} // Middle card bg
          >
            {/* Icon */}
            <div className="w-[66px] h-[66px] relative">
              <Image
                src={card.icon}
                alt={card.title}
                fill
                className="object-contain"
                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
              />
            </div>

            {/* Content */}
            <div className="flex flex-col 2xl:gap-6 gap-2">
              <h3 className="text-[clamp(1.75rem,1.2512rem+1.0393vw,2.875rem)] leading-[140%] clash-font font-medium text-[#00040b]">
                {card.title}
              </h3>

              <div className="flex flex-col gap-2">
                {" "}
                {/* Added small gap between items */}
                {card.items?.map((item, itemIdx) => (
                  <div key={itemIdx} className="flex items-start gap-2">
                    {/* Bullet Point */}
                    <span className="text-[#636364] text-[20px] leading-[180%]">
                      •
                    </span>

                    <p className="text-[#636364] text-[20px] leading-[180%] font-medium">
                      {item}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
